import { defineComponent } from 'vue'
import { BlockModule } from '../common'
import { swup } from '@/lib/swup'
import { useDownloadsContext } from '../downloads-page/composables'
 
new BlockModule({
    selector: '.block-search-bar-downloads',
    vueComponent: defineComponent({
        name: 'block-search-bar-downloads',
        props: {
            noTearDown: String,
            searchPageKey: String,
            searchPageBaseUrl: String,
        },
        setup(props) {
            const {
                isSearchPage,
                searchTerm,
                onSearch
            } = useDownloadsContext()

 
            // The shared `searchTerm` ref lives at module scope in
            // useDownloadsContext, so it survives navigation. Re-sync it
            // to the current URL on every mount so the input doesn't
            // show a stale query after navigating to another page.
            const urlParams = new URLSearchParams(window.location.search)
            searchTerm.value = urlParams.get('searchTerm') ?? ''
 
            const search = () => {
                if (!isSearchPage.value) {
                    swup.navigate(`${props.searchPageBaseUrl}?searchTerm=${encodeURIComponent(searchTerm.value.trim())}`)
                } else {
                    onSearch()
                }
            }
 
            return {
                search,
                searchTerm,
            }
        },
    }),
})
 